<template>
  <b-modal id="modal-barang" ref="modalBarang" title="Tambah Barang" variant="success" size="lg" hide-footer
    no-close-on-esc no-close-on-backdrop>
    <loading :active.sync="this.$store.state.barpin.isLoadingModal" :is-full-page="false"></loading>
    <form @submit.prevent="addBarang">
      <b-form-fieldset label="Uraian Barang">
        <b-form-input type="text" name="Uraian Barang" :class="errors.has('Uraian Barang') ? 'is-invalid' : ''"
          placeholder="..." v-validate="'required'" v-model="barang.uraian_barang"></b-form-input>
        <div v-show="errors.has('Uraian Barang')" class="invalid-feedback">{{ errors.first('Uraian Barang') }}</div>
      </b-form-fieldset>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jumlah Satuan">
            <b-form-input type="number" name="Jumlah Satuan" placeholder="..."
              :class="errors.has('Jumlah Satuan') ? 'is-invalid' : ''" v-model="barang.jml_satuan"
              v-validate="'required'"></b-form-input>
            <div v-show="errors.has('Jumlah Satuan')" class="invalid-feedback">{{ errors.first('Jumlah Satuan') }}</div>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jenis Satuan">
            <model-list-select class="form-control" :list="satuan" option-value="JNS_SAT"
              :custom-text="(item) => `${item.JNS_SAT} - ${item.UR_SAT}`" v-model="barang.jns_satuan"
              name="Jenis Satuan" v-validate="'required'" :class="errors.has('Jenis Satuan') ? 'is-invalid' : ''"
              placeholder="Jenis Satuan"></model-list-select>
            <div v-show="errors.has('Jenis Satuan')" class="invalid-feedback">{{ errors.first('Jenis Satuan') }}</div>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jumlah Kemasan">
            <b-form-input type="number" placeholder="..." v-model="barang.jml_kemasan" name="Jumlah Kemasan"
              v-validate="'required'" :class="errors.has('Jumlah Kemasan') ? 'is-invalid' : ''"></b-form-input>
            <div v-show="errors.has('Jumlah Kemasan')" class="invalid-feedback">{{ errors.first('Jumlah Kemasan') }}
            </div>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jenis Kemasan">
            <model-list-select class="form-control" :list="kemasan" option-value="JNS_KMS"
              :custom-text="(item) => `${item.JNS_KMS} - ${item.UR_KMS}`" v-model="barang.jns_kemasan"
              v-validate="'required'" name="Jenis Kemasan" :class="errors.has('Jenis Kemasan') ? 'is-invalid' : ''"
              placeholder="Jenis Kemasan"></model-list-select>
            <div v-show="errors.has('Jenis Kemasan')" class="invalid-feedback">{{ errors.first('Jenis Kemasan') }}</div>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Bruto">
            <!-- <b-form-input type="number" placeholder="..." v-model="barang.bruto"></b-form-input> -->
            <vue-numeric class="form-control" :class="errors.has('bruto') ? 'is-invalid' : ''" currency="Kg"
              v-validate="'required'" currency-symbol-position="suffix" separator="." placeholder="Bruto Barang"
              v-bind:precision="2" name="bruto" v-model="barang.bruto" required>
            </vue-numeric>
            <div v-show="errors.has('bruto')" class="invalid-feedback">{{ errors.first('bruto') }}</div>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Netto">
            <!-- <b-form-input type="number" placeholder="..." v-model="barang.netto"></b-form-input> -->
            <vue-numeric class="form-control" currency="Kg" currency-symbol-position="suffix" separator="."
              placeholder="Netto Barang" v-bind:precision="2" v-model="barang.netto" v-validate="'required'"
              name="netto" required>
            </vue-numeric>
            <div v-show="errors.has('netto')" class="invalid-feedback">{{ errors.first('netto') }}</div>
          </b-form-fieldset>
        </div>
      </div>
      <b-form-fieldset label="Nilai Barang (Rp)">
        <vue-numeric class="form-control" currency="Rp" separator="." decimal="0" v-model="barang.nilai_barang"
          v-validate="'required'" name="Nilai Barang" required>
        </vue-numeric>
        <div v-show="errors.has('Nilai Barang')" class="invalid-feedback">{{ errors.first('Nilai Barang') }}</div>
      </b-form-fieldset>
      <b-form-fieldset label="HS Code">
        <b-form-input v-model="barang.hs_code" maxlength="8" type="text"></b-form-input>
        <!-- <vue-numeric class="form-control" output-type="String" v-model="hs_code"></vue-numeric> -->
        <div v-show="errors.has('Nilai Barang')" class="invalid-feedback">{{ errors.first('Nilai Barang') }}</div>
      </b-form-fieldset>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Tarif Bea Masuk">
            <b-input-group right="%">
              <vue-numeric class="form-control" :minus="false" :precision="1" v-model="barang.tarif_bm"></vue-numeric>
            </b-input-group>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Nilai Bea Masuk">
            <vue-numeric disabled class="form-control" currency="Rp" separator="." :value="nilai_bm"></vue-numeric>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Tarif PPN">
            <b-input-group right="%">
              <vue-numeric class="form-control" :minus="false" :precision="1" v-model="barang.tarif_ppn"></vue-numeric>
            </b-input-group>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Nilai PPN">
            <vue-numeric disabled class="form-control" currency="Rp" separator="." :value="nilai_ppn"></vue-numeric>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Tarif PPh">
            <b-input-group right="%">
              <vue-numeric class="form-control" :minus="false" :precision="1" v-model="barang.tarif_pph"></vue-numeric>
            </b-input-group>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Nilai PPh">
            <vue-numeric disabled class="form-control" currency="Rp" separator="." :value="nilai_pph"></vue-numeric>
          </b-form-fieldset>
        </div>
      </div>
      <slot id="footer">
        <hr />
        <button type="submit" class="btn btn-success pull-right">
          <i class="fa fa-plus"></i> Tambah
        </button>
      </slot>
    </form>
  </b-modal>
</template>
<script>
import {mapActions} from 'vuex'
import swal from 'sweetalert'
export default {
  data () {
    return {
      satuan: [],
      kemasan: [],
      barang: {
        uraian_barang: '',
        jml_satuan: '',
        jns_satuan: '',
        jml_kemasan: '',
        jns_kemasan: '',
        bruto: 0,
        netto: 0,
        nilai_barang: 0,
        tarif_bm: '',
        // nilai_bm: '',
        tarif_ppn: '',
        nilai_ppn: '',
        tarif_pph: '',
        nilai_pph: '',
        hs_code: ''
      }
    }
  },
  computed: {
    nilai_bm () {
      return this.barang.nilai_barang * (this.barang.tarif_bm / 100)
    },
    nilai_ppn () {
      return (this.barang.nilai_barang + this.nilai_bm) * (this.barang.tarif_ppn / 100)
    },
    nilai_pph () {
      return (this.barang.nilai_barang + this.nilai_bm) * (this.barang.tarif_pph / 100)
    }
  },
  created () {
    this.getSatuan()
    this.getKemasan()
  },
  methods: {
    ...mapActions({
      setBarang: 'barpin/setBarang'
    }),
    addBarang () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('barpin/SET_LOADING_MODAL', true)
          var dataSet = {
            ...this.barang,
            id_aju: this.$store.state.barpin.header.id_aju,
            nilai_bm: this.nilai_bm,
            nilai_ppn: this.nilai_ppn,
            nilai_pph: this.nilai_pph
          }
          this.setBarang(dataSet).then(() => {
            this.$refs['modalBarang'].hide()
            this.$store.commit('barpin/SET_LOADING_MODAL', false)
          }).catch((error) => {
            swal('error', JSON.stringify(JSON.parse(error.bodyText).errors), 'error')
            this.$store.commit('barpin/SET_LOADING_MODAL', false)
          })
        }
      })
    },
    getSatuan () {
      this.$http.get('ref/jnsatuan').then((response) => {
        this.satuan = response.data
      })
    },
    getKemasan () {
      this.$http.get('ref/jnskemasan').then((response) => {
        this.kemasan = response.data
      })
    }
    // formatNpwp () {
    //   this.barang.hs_code = 'tes'
    //   console.log(this.barang.hs_code.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, '$1.$2.$3.$4-$5.$6'))
    // }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalBarang.vue?7142d922